import logo from './logo.svg';
import './App.css';
import About from './About.js';
import Nav from 'react-bootstrap/Nav';
import Gallery from './Gallery.js';
import Contact from './Contact.js';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
    <Navbar collapseOnSelect expand="lg" bg="primary" variant="dark" >
    <Navbar.Brand href=" " style={{fontSize: '24px'}}>Bienvenidos Amigos</Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
    <Navbar.Collapse id="responsive-navbar-nav">
      <Nav className="mr-auto">
      </Nav>
      <Nav>
        <Nav.Link href="#gallery" style={{color: '#fff', fontSize: '20px'}}>Gallery</Nav.Link>
        <Nav.Link href="#contact" style={{color: '#fff', fontSize: '20px'}}>Contact</Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
  <About/>
  <Gallery/>
  <Contact/>
  <br/><br/><br/><a href="https://www.instagram.com/im_babumoshai_/" target="/blank" style={{fontSize: 22, fontWeight: 'bold', textDecoration: 'none'}}>Find me on <img src="./photos/instagram-logo.png" style={{width : 40, height: 40}}/> Instagram</a>
      <h6 style={{color: '#333', marginTop:70, marginBottom:50}}>&copy; Copyright 2021 | Ratul Sarkar | All Rights Reserved</h6>
    </div>
  );
}

export default App;
